import React from "react";
import "./Sort_Offcanvas.css";
import { Form, Offcanvas } from "react-bootstrap";

const Sort_Offcanvas = ({show,onHide,selectedOption, setSelectedOption, ...props}) => {
    
  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
    //  console.log("SORT OPTION SELECTED:", event.target.value);
    onHide()
  };

  return (
    <Offcanvas show={show} onHide={onHide} className="sort_offcanvas" placement="end">
      <Offcanvas.Header >
        <div className="logo_div">
          <img
            src={process.env.PUBLIC_URL + "/assets/images/logo/logo.png"}
            className="logo"
          />
        </div>
        <div className="close_div" onClick={onHide}>
          <img
            src="/assets/images/icons/close_white.png"
            className="close_img"
          />
        </div>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="inner_div">
          <Form className="form-holder">
            <Form.Group>
              {/* Default */}
              <div className="radio-btn-text-holder">
                <label
                  className={
                    selectedOption === ""
                      ? "radio_lable_holder active"
                      : "radio_lable_holder"
                  }
                >
                  <p className="label_text">Default</p>

                  <Form.Check
                    type="radio"
                    name="sortOptions"
                    value=""
                    checked={selectedOption === ""}
                    onChange={handleOptionChange}
                  />
                </label>
              </div>


              {/* Price - High to Low */}
              <div className="radio-btn-text-holder">
                <label
                  className={
                    selectedOption === "DESC"
                      ? "radio_lable_holder active"
                      : "radio_lable_holder"
                  }
                >
                  <p className="label_text">Price - High to Low</p>
                  <Form.Check
                    type="radio"
                    name="sortOptions"
                    value="DESC"
                    checked={selectedOption === "DESC"}
                    onChange={handleOptionChange}
                  />
                </label>
              </div>

              {/* Price - Low to High */}
              <div className="radio-btn-text-holder">
                <label
                  className={
                    selectedOption === "ASC"
                      ? "radio_lable_holder active"
                      : "radio_lable_holder"
                  }
                >
                  <p className="label_text">Price - Low to High</p>
                  <Form.Check
                    type="radio"
                    name="sortOptions"
                    value="ASC"
                    checked={selectedOption === "ASC"}
                    onChange={handleOptionChange}
                  />
                </label>
              </div>
            </Form.Group>
          </Form>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default Sort_Offcanvas;
